import { prettyFileSize } from '@fiverr-private/futile/lib/file/prettyFileSize';
import { fileSizeFormat } from '@fiverr-private/localization';
import * as CurrentsSelectors from '../current';

export const getFilerrs = (state = {}) =>
    state.filerrs || {};

export const getFilerrIds = (state = {}) =>
    Object.keys(getFilerrs(state));

export const getFilerrById = (state = {}, id) =>
    getFilerrs(state)[id] || {};

export const getCurrentFilerr = (state = {}) =>
    getFilerrById(state, CurrentsSelectors.getCurrentFilerrId(state)) || {};

export const getThumbUrlById = (state = {}, id) => {
    const filerr = getFilerrById(state, id);
    const { previewUrls } = filerr || {};
    const { thumbnail, thumb, thumbLarge } = previewUrls || {};

    return thumbnail || thumb || thumbLarge;
};

export const getPreviewTypeById = (state = {}, id) => {
    const filerr = getFilerrById(state, id);
    const { previewType } = filerr || {};

    return previewType;
};

export const getCurrentFilerrPreviewType = (state = {}) => {
    const currentFilerrId = CurrentsSelectors.getCurrentFilerrId(state);

    return getPreviewTypeById(state, currentFilerrId);
};

export const getDownloadUrlById = (state = {}, id) => {
    const filerr = getFilerrById(state, id);
    const { downloadUrl } = filerr || {};

    return downloadUrl;
};

export const getCurrentFilerrDownloadUrl = (state = {}) => {
    const currentFilerrId = CurrentsSelectors.getCurrentFilerrId(state);

    return getDownloadUrlById(state, currentFilerrId);
};

export const getFileNameById = (state = {}, id) => {
    const filerr = getFilerrById(state, id);
    const { fileName } = filerr || {};

    return fileName;
};

export const getFileSizeById = (state = {}, id) => {
    const filerr = getFilerrById(state, id);
    const { fileSize } = filerr || {};

    return fileSize;
};

export const getFileSizeWithUnitsById = (state = {}, id) => {
    const fileSize = getFileSizeById(state, id);

    return isNaN(fileSize) ?
        '' :
        fileSizeFormat(fileSize, {
            fallbackValue: prettyFileSize(fileSize)
        });
};

export const isEmpty = (state = {}) =>
    getFilerrIds(state).length === 0;

export const isMoreThanOne = (state = {}) =>
    getFilerrIds(state).length > 1;

export const getNextFilerrId = (state = {}) => {
    const filerrIds = getFilerrIds(state);
    const filerrIdsLength = filerrIds.length;
    const currentFilerrId = CurrentsSelectors.getCurrentFilerrId(state);

    const currentIndex = filerrIds.indexOf(currentFilerrId);
    const nextIndex = (((currentIndex + 1) % filerrIdsLength) + filerrIdsLength) % filerrIdsLength;

    return filerrIds[nextIndex];
};

export const getPreviousFilerrId = (state = {}) => {
    const filerrIds = getFilerrIds(state);
    const filerrIdsLength = filerrIds.length;
    const currentFilerrId = CurrentsSelectors.getCurrentFilerrId(state);

    const currentIndex = filerrIds.indexOf(currentFilerrId);
    const previousIndex = (((currentIndex - 1) % filerrIdsLength) + filerrIdsLength) % filerrIdsLength;

    return filerrIds[previousIndex];
};
